/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancellationAccountForm
 */
export interface CancellationAccountForm {
    /**
     * 
     * @type {string}
     * @memberof CancellationAccountForm
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof CancellationAccountForm
     */
    feedback?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CancellationAccountForm
     */
    contactNotAllowed?: boolean;
}

/**
 * Check if a given object implements the CancellationAccountForm interface.
 */
export function instanceOfCancellationAccountForm(value: object): value is CancellationAccountForm {
    return true;
}

export function CancellationAccountFormFromJSON(json: any): CancellationAccountForm {
    return CancellationAccountFormFromJSONTyped(json, false);
}

export function CancellationAccountFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancellationAccountForm {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
        'feedback': json['feedback'] == null ? undefined : json['feedback'],
        'contactNotAllowed': json['contactNotAllowed'] == null ? undefined : json['contactNotAllowed'],
    };
}

export function CancellationAccountFormToJSON(value?: CancellationAccountForm | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'feedback': value['feedback'],
        'contactNotAllowed': value['contactNotAllowed'],
    };
}

